import '.fp{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fq{padding-left:1.5rem;}.ssr-plugin'
import '.fr{margin:1rem 0;}.ssr-plugin'
import '.fs{color:var(--gray-700);}.ssr-plugin'
import '.ft{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fp fq fr fs ft"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
